export default __webpack_public_path__ + "static/media/hexagons-down.b6c73264.svg";